import { useQueryClient } from '@tanstack/react-query';

import { useQuery } from '@hooks/reactQuery';

import { getActiveOranAlarms } from '@api/alarmHistory';

import { extractQueryParams } from '@utils/common';

import { IActiveAlarmOran } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { ACTIVE_ALARM_ORAN, ACTIVE_ALARMS_ORAN } from '@constants/queryKeys';

interface IUseQueryActiveAlarmsListOranReturn {
	isLoading: boolean;
	data: IActiveAlarmOran[];
	countOfRecords: number;
	invalidateQuery: () => void;
}

export const useQueryActiveAlarmsListOran = (
	params: IAlarmByVendor,
): IUseQueryActiveAlarmsListOranReturn => {
	const queryClient = useQueryClient();

	const { isEnabled: isEnabledTab, ...restParams } = params;

	const {
		data,
		isInitialLoading: isLoadingAlarmsOran,
	} = useQuery({
		queryKey: [ACTIVE_ALARMS_ORAN, restParams],
		queryFn: extractQueryParams(getActiveOranAlarms),
		enabled: [isEnabledTab],
		refetchOnWindowFocus: false,
	});

	const invalidateQuery = () => {
		return [
			queryClient.invalidateQueries([ACTIVE_ALARMS_ORAN]),
			queryClient.invalidateQueries([ACTIVE_ALARM_ORAN]),
		];
	};

	return {
		isLoading: isLoadingAlarmsOran,
		data: data?.items || [],
		countOfRecords: data?.count || 0,
		invalidateQuery,
	};
};
